import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const dashboardImg =
  "https://static.prod-images.emergentagent.com/jobs/7d38956f-74c5-4266-a29e-5f2f50e06042/images/6e5b1350beb6b5621fe0733be4d7eaaff2f1795de206d9a4395ad7a508ed8c31.png";

export default function Portfolio() {
  const { t } = useLang();
  return (
    <section id="work" className="py-24 lg:py-32 relative" data-testid="portfolio-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-7">
            <p className="bbm-eyebrow mb-4">— {t.portfolio.eyebrow}</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0B132B] leading-tight tracking-tight">
              {t.portfolio.title}
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[#4B5563] text-lg leading-relaxed">{t.portfolio.sub}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.portfolio.items.map((p, i) => (
            <div
              key={i}
              className="bbm-card overflow-hidden flex flex-col group"
              data-testid={`portfolio-card-${i}`}
            >
              {/* Visual */}
              <div className="relative aspect-[16/10] overflow-hidden bg-[#F3F4F6]">
                <img
                  src={dashboardImg}
                  alt={p.title}
                  className="w-full h-full object-cover opacity-95 transition-transform duration-500 group-hover:scale-105"
                />
                <div
                  className="absolute inset-0 mix-blend-multiply opacity-40"
                  style={{ background: p.color }}
                />
                <div className="absolute top-3 start-3 bg-white/95 backdrop-blur px-3 py-1 rounded-sm font-mono text-[10px] uppercase tracking-widest text-[#0B132B]">
                  {p.tag}
                </div>
                <div className="absolute bottom-3 end-3 bg-[#FFB800] text-[#0B132B] px-3 py-1 rounded-sm font-display text-sm">
                  {p.metric}
                </div>
              </div>

              <div className="p-6 flex-1 flex flex-col justify-between">
                <h3 className="font-display text-lg text-[#0B132B] leading-snug mb-4">
                  {p.title}
                </h3>
                <button
                  className="inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-widest text-[#0047FF] hover:text-[#0036CC] self-start"
                  data-testid={`portfolio-case-${i}`}
                >
                  {t.portfolio.view}
                  <ArrowUpRight className="w-3.5 h-3.5 bbm-flip" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
